import { OverridedUserLocation } from '@/utils/formatters/city/format-place-from-slug.const';

export enum SearchType {
  ALL = 'ALL',
  LABORATORIAL_EXAM = 'LABORATORIAL_EXAM',
  ONLINE_CONSULTATION = 'ONLINE_CONSULTATION',
  PRESENTIAL_CONSULTATION = 'PRESENTIAL_CONSULTATION',
  DOCTOR = 'DOCTOR',
  VACCINE = 'VACCINE',
  IMAGE_EXAM = 'IMAGE_EXAM',
  CLINIC = 'CLINIC',
  EMERGENCY = 'EMERGENCY',
  SURGERY = 'SURGERY',
  BRANCH_LABORATORY = 'BRANCH_LABORATORY',
  PARTNER = 'PARTNER',
  PROFESSIONAL = 'PROFESSIONAL',
  PROCEDURE = 'PROCEDURE',
}

export type RecentSearches = SearchResult & {
  examOrVaccineGroup?: SearchResult[];
};

export type SearchResult = {
  id?: string;
  avatar?: string;
  name?: string;
  code?: string;
  description?: string | null;
  procedureType?: string;
  tussCode?: string;
  displayName?: string;
  subText?: string | null;
  slug?: string | null;
  alias?: string;
  keywords?: string[];
  specialties?: string[];
  availableForTelehealth?: boolean;
  searchType: SearchType;
  source?: string;
  city?: string;
  state?: string;
};

export type SearchHealthResourcesResponse = {
  results: SearchResult[];
  total: number;
};

export type AllSearchResults = {
  [SearchType.ALL]: SearchHealthResourcesResponse;
  [SearchType.PROCEDURE]: SearchHealthResourcesResponse;
  [SearchType.PROFESSIONAL]: SearchHealthResourcesResponse;
  [SearchType.PARTNER]: SearchHealthResourcesResponse;
};

export interface SelectedProcedures {
  id: string;
  code: string;
  displayName: string;
  examOrVaccineGroup?: SelectedProcedures[];
}

export interface SearchModalProps {
  initialSelectedProcedures?: SelectedProcedures[];
  initialKey?: string;
  isVaccineSearch?: boolean;
  isLaboratorialSearch?: boolean;
  locationOverride?: OverridedUserLocation;
}
